<template>
  <v-app id="inspire">
    <Header type="return-search" @changeClient="fetchFeedSearch($event)" />
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Профиль клиента</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Клиенты /</span> Карточка клиента</div>
                </div>
                <div v-show="tab === 0">
                  <v-btn
                      :to="{ name: 'Sale', params: {client: client.client, buy_id: null, type: 'new', for: 'client', deal: null} }"
                      class="sale-button"
                      style="margin-right:10px;"
                  >
                    Продажа
                  </v-btn>
                  <v-btn
                      color="#629F33"
                      class="button__success"
                      @click="updateClient"
                      :disabled="isLoading"
                  >
                    Сохранить изменения
                  </v-btn>
                </div>
              </v-col>
              <v-col
                  cols="2"
              >
                <v-tabs v-model="tab" vertical id="vertical_tabs">
                  <v-tab
                      v-for="item in items"
                      :v-model="menu_tab"
                      :key="item.id"
                      :value="item.id"
                  >
                    {{ item.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>
              <v-col
                  cols="10"
              >
                <template v-if="clientUpdated && sucupd">
                  <v-alert
                      v-if="clientUpdated.success"
                      @input="clientUpdated.success = false"
                      dismissible
                      dense
                      type="success"
                  >Изменения успешно сохранены</v-alert>
                </template>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-row align="stretch">
                      <v-col
                          md="4"
                          class="dflex align-center"
                      >
                        <v-skeleton-loader
                          v-if="isLoading && ($route.path === '/card-client')"
                          type="card-avatar, actions"
                        >
                        </v-skeleton-loader>
                        <v-sheet rounded="lg" class="card" v-else>
                          <span class="card-title">Фото клиента</span>
                          <div class="edit-avatar">
                            <div class="user-avatar">
                              <img
                                  v-if="!isCameraOpen"
                                  :src="client.client.photo ? client.client.photo : '/playground_assets/mediumcamera3282-238l.svg'"
                                  :style="client.client.photo ? 'height: 210px; width: 210px; border-radius: 145px;' : 'height: 37px; width: 46px'"
                              />
                              <div v-show="isCameraOpen && isLoading2" class="camera-loading">
                                  <ul class="loader-circle">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                  </ul>
                                </div>
                                <div v-if="isCameraOpen" v-show="!isLoading2" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                  <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                  <video v-show="!isPhotoTaken" style="border-radius:100%;" ref="camera" :width="210" :height="210" autoplay></video>
                                  <canvas v-show="isPhotoTaken" style="border-radius:100%;" id="photoTaken" ref="canvas" :width="210" :height="210"></canvas>
                                </div>
                            </div>
                            <div class="edit-button">
                              <v-row style="align-items: center; justify-content: center;">
                                <v-btn type="button" class="button__lighten-success" @click="toggleCamera">
                                    <span v-if="!isCameraOpen">Изменить фото</span>
                                    <span v-else>Закрыть камеру</span>
                                  </v-btn>
                                  <div v-if="isCameraOpen && !isLoading2 && !isPhotoTaken" class="camera-shoot" style="padding-top:20px;">
                                    <button type="button" class="button" @click="takePhoto" style="width:40px; height:40px;padding:2px 0px;">
                                      <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png" style="width:30px; height:30px;padding:0px;">
                                    </button>
                                  </div>
                                  
                                  <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download" style="width:100px;height:40px; padding-top:10px;">
                                    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                                      Сохранить
                                    </a>
                                  </div> -->
                              </v-row>
                            </div>
                          </div>
                          <div>
                          <v-btn :to="{ name: 'CardClientNew', params: {client_id: client_id} }" class="button button__lighten"
                           style="min-width: 100% !important; margin-top: 30px !important;">
                          Карточка клиента
                        </v-btn>
                      </div>
                        </v-sheet>

      
                      </v-col>
                      <v-col
                          md="8"
                          :class="isLoading ? '' : 'd-flex'"
                      >
                        <v-skeleton-loader
                            v-if="isLoading && ($route.path === '/card-client')"
                            type="article"
                        >
                        </v-skeleton-loader>
                        <v-sheet rounded="lg" class="card" v-else>
                          <span class="card-title">Общая информация</span>
                          <v-row class="mt-2">
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Фамилия</label>
                              <v-text-field
                                  v-model="client.client.last_name"
                                  label="Фамилия"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Имя</label>
                              <v-text-field
                                  v-model="client.client.first_name"
                                  label="Имя"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Отчество</label>
                              <v-text-field
                                  v-model="client.client.middle_name"
                                  label="Отчество"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Дата рождения</label>
                              <template>
                                <VueDatePicker
                                    no-title
                                    no-header
                                    color="#629f34"
                                    :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                                    :maxDate="new Date()"
                                    v-model="client.client.date_birth"
                                    placeholder="Выбрать"
                                >
                                  <template #activator="{ date }">
                                    <button
                                        class="button custom__datepicker"
                                        ref="activator"
                                        type="button"
                                    >
                                      {{ date }}
                                      <v-icon
                                          medium
                                          right
                                          class="ml-5"
                                      >
                                        mdi-calendar-blank-outline
                                      </v-icon>
                                    </button>
                                  </template>
                                </VueDatePicker>
                              </template>
                            </v-col>
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Номер телефона</label>
                              <div style="display:flex; align-items: center;">
                                  <v-text-field
                                    v-model="client.client.phone[0]"
                                    label="Номер телефона"
                                    v-mask="'+7 (###) ###-##-##'"
                                    outlined
                                    dense
                                    style="height: 48px;margin-top: 10px"
                                    class="rounded-lg"
                                ></v-text-field>
                                <button class="btn-icon ml-auto" @click="callOut(client.client.phone[0])">
                                  <v-icon small>mdi-phone</v-icon>
                                </button>
                              </div>
                              <div style="display:flex; align-items: center;" v-if="client.client.phone[1]">
                                  <v-text-field
                                    v-model="client.client.phone[1]"
                                    label="Номер телефона"
                                    v-mask="'+7 (###) ###-##-##'"
                                    outlined
                                    dense
                                    style="height: 48px;margin-top: 10px"
                                    class="rounded-lg"
                                ></v-text-field>
                                <button class="btn-icon ml-auto" @click="callOut(client.client.phone[1])">
                                  <v-icon small>mdi-phone</v-icon>
                                </button>
                              </div>
                              <div style="display:flex; align-items: center;" v-else>
                                  <v-text-field
                                    v-model="client.client.phone[1]"
                                    label="Номер телефона"
                                    v-mask="'+7 (###) ###-##-##'"
                                    outlined
                                    dense
                                    style="height: 48px;margin-top: 10px"
                                    class="rounded-lg"
                                ></v-text-field>
                                <button class="btn-icon ml-auto" @click="callOut(client.client.phone[1])">
                                  <v-icon small>mdi-phone</v-icon>
                                </button>
                              </div>

                              <!-- <v-btn
                                  type="button"
                                  class="button__activate"
                                  style="margin-top: 0 !important;"
                                  @click="callOut"
                              >
                                <span>Позвонить</span>
                              </v-btn> -->

                            </v-col>
                            <v-col
                                md="6"
                                sm="12"
                            >
                              <label>Почта</label>
                              <v-text-field
                                  v-model="client.client.email"
                                  :rules="emailRules"
                                  label="Почта"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-skeleton-loader
                            v-if="isLoading && ($route.path === '/card-client')"
                            type="article"
                        >
                        </v-skeleton-loader>
                        <v-sheet rounded="lg" class="card" v-else>
                          <span class="card-title">
                            Данные по карте
                          </span>
                          <v-row v-for="card in client.client.cards" :key="card.card_id" class="mt-2">
                            <v-col
                                md="4"
                            >
                              <label>Номер карты</label>
                              <v-text-field
                                  v-model="card.card_number"
                                  :rules="cardNumberRules"
                                  label="Номер карты"
                                  outlined
                                  dense
                                  style="height: 48px;margin-top: 10px"
                                  class="rounded-lg"
                              ></v-text-field>
                            </v-col>
                            <v-col
                              md="4"
                              style="margin-top: 14px !important;"
                            >
                              <v-skeleton-loader
                                v-if="isLoading && ($route.path === '/card-client')"
                              >
                              </v-skeleton-loader>
                              <v-btn
                                  :class="card.card_status === 2 ? 'button__unlock' : 'button__danger'"
                                  style="height: 40px !important;"
                                  @click="card.card_status === 2 ? unlock(card.card_id) : block(card.card_id)"
                              >
                                {{ card.card_status === 2 ? 'Разблокировать' : 'Заблокировать'}}
                              </v-btn>
                            </v-col>
                          </v-row>
                          <br v-show="!client.client.cards.length">
                          <v-btn class="button__lighten-success" @click="dialogCard = true">
                            Добавить
                          </v-btn>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                          <div style="padding: 20px 20px 0 20px">
                            <span class="card-title">Лицевые и бонусные счета</span>
                          </div>
                          <v-skeleton-loader
                              v-if="isLoading && ($route.path === '/card-client')"
                              type="table"
                          >
                          </v-skeleton-loader>
                          <v-data-table
                              v-else
                              :headers="headersAccount"
                              :items="client.client.main_bonus_bill"
                              :hide-default-footer="true"
                              disable-pagination
                              item-key="type"
                              class="elevation-1 mt-3 rounded-b-0 custom__table"
                          >
                            <template v-slot:item.balance="{ item }">
                              {{ item.balance }} ₽
                            </template>
                          </v-data-table>
                          <v-skeleton-loader
                              v-if="isLoading && ($route.path === '/card-client')"
                              type="button"
                          >
                          </v-skeleton-loader>
                          <v-btn v-else class="button__lighten-success" @click="modalBillPayment" style="margin: 20px 0 20px 20px">
                            Внести средства
                          </v-btn>
                        </v-sheet>
                      </v-col>
                    </v-row>



                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-skeleton-loader
                            v-if="isLoading && ($route.path === '/card-client')"
                            type="article"
                        >
                        </v-skeleton-loader>
                        <template v-else>
                          <v-sheet rounded="lg" class="card" >
                              <v-row class="mt-2">
                                <v-col
                                    md="4"
                                    v-if="listPlatforms"
                                >


              
                      <div class="card-title" style="margin-bottom:10px;">Канал привлечения</div>
                      <v-select
                          v-model="client.client.advertising_platform"
                          class="rounded-lg custom__select"
                          :items="listPlatforms.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Канал привлечения"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          style="height: 48px;"
                      >
                      </v-select>
                    </v-col>
                    </v-row>
                    </v-sheet>
                    </template>
                  </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-skeleton-loader
                            v-if="isLoading && ($route.path === '/card-client')"
                            type="article"
                        >
                        </v-skeleton-loader>
                        <template v-else>
                          <v-sheet rounded="lg" class="card" >
                              <v-row class="mt-2">
                                <v-col
                                    md="4"
                                    v-if="listSources"
                                >


              
                      <div class="card-title" style="margin-bottom:10px;">Рекламный источник</div>
                      <v-select
                          v-model="client.client.advertising_source"
                          class="rounded-lg custom__select"
                          :items="listSources.advertising ?? []"
                          item-value="id"
                          item-text="name"
                          :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                          placeholder="Рекламный источник"
                          append-icon="mdi-chevron-down"
                          outlined
                          dense
                          style="height: 48px;"
                      >
                      </v-select>
                    </v-col>
                    </v-row>
                    </v-sheet>
                    </template>
                  </v-col>
                    </v-row>

    
                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-skeleton-loader
                            v-if="isLoading && ($route.path === '/card-client')"
                            type="article"
                        >
                        </v-skeleton-loader>
                        <template v-else>
                          <v-sheet rounded="lg" class="card" v-if="client.client.documents && client.client.documents.length > 0">
                            <div v-for="(document, index) in client.client.documents" :key="document.type">
                              <span class="card-title">Удостоверение личности №{{ index + 1 }}</span>
                              <v-row class="mt-2">
                                <v-col
                                    md="4"
                                >
                                  <label>Вид документа</label>
                                  <v-select
                                      :value="document.type"
                                      class="rounded-lg custom__select"
                                      :items="[document.type]"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Вид документа"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <!-- <label>Гражданство</label>
                                  <v-select
                                      :value="document.nationality"
                                      class="rounded-lg custom__select"
                                      :items="[document.nationality]"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Гражданство"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select> -->
                                  <label>Код подразделения</label>
                                  <v-text-field
                                      v-model="document.code"
                                      label="Код подразделения"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                    md="4"
                                >
                                  <label>Серия документа</label>
                                  <v-text-field
                                      v-model="document.seria"
                                      label="Серия документа"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <label>Номер документа</label>
                                  <v-text-field
                                      v-model="document.number"
                                      label="Номер документа"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                    md="4"
                                >
                                  <label>Дата выдачи</label>
                                  <template>
                                    <VueDatePicker
                                        no-title
                                        no-header
                                        color="#629f34"
                                        :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                                        :maxDate="new Date()"
                                        v-model="document.date_start"
                                        placeholder="Выбрать"
                                    >
                                      <template #activator="{ date }">
                                        <button
                                            class="button custom__datepicker"
                                            ref="activator"
                                            type="button"
                                        >
                                          {{ date }}
                                          <v-icon
                                              medium
                                              right
                                              class="ml-5"
                                          >
                                            mdi-calendar-blank-outline
                                          </v-icon>
                                        </button>
                                      </template>
                                    </VueDatePicker>
                                  </template>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <label>Кем выдан</label>
                                  <v-text-field
                                      v-model="document.issued"
                                      label="Кем выдан"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </v-sheet>

                          <v-sheet rounded="lg" class="card" v-else>
                            <div v-for="(document, index) in documents_def" :key="document.type">
                              <span class="card-title">Удостоверение личности №{{ index + 1 }}</span>
                              <v-row class="mt-2">
                                <v-col
                                    md="4"
                                >
                                  <label>Вид документа</label>
                                  <v-select
                                      :value="document.type"
                                      class="rounded-lg custom__select"
                                      :items="[document.type]"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Вид документа"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <!-- <label>Гражданство</label>
                                  <v-select
                                      :value="document.nationality"
                                      class="rounded-lg custom__select"
                                      :items="[document.nationality]"
                                      :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                      label="Гражданство"
                                      append-icon="mdi-chevron-down"
                                      outlined
                                      dense
                                      required
                                      style="height: 48px;margin-top: 10px"
                                  ></v-select> -->
                                  <label>Код подразделения</label>
                                  <v-text-field
                                      v-model="document.code"
                                      label="Код подразделения"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                    md="4"
                                >
                                  <label>Серия документа</label>
                                  <v-text-field
                                      v-model="document.seria"
                                      label="Серия документа"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <label>Номер документа</label>
                                  <v-text-field
                                      v-model="document.number"
                                      label="Номер документа"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                    md="4"
                                >
                                  <label>Дата выдачи</label>
                                  <template>
                                    <VueDatePicker
                                        no-title
                                        no-header
                                        color="#629f34"
                                        :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                                        :maxDate="new Date()"
                                        v-model="document.date_start"
                                        placeholder="Выбрать"
                                    >
                                      <template #activator="{ date }">
                                        <button
                                            class="button custom__datepicker"
                                            ref="activator"
                                            type="button"
                                        >
                                          {{ date }}
                                          <v-icon
                                              medium
                                              right
                                              class="ml-5"
                                          >
                                            mdi-calendar-blank-outline
                                          </v-icon>
                                        </button>
                                      </template>
                                    </VueDatePicker>
                                  </template>
                                </v-col>
                                <v-col
                                    md="4"
                                >
                                  <label>Кем выдан</label>
                                  <v-text-field
                                      v-model="document.issued"
                                      label="Кем выдан"
                                      outlined
                                      dense
                                      style="height: 48px;margin-top: 10px"
                                      class="rounded-lg"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </v-sheet>

                        </template>
                      </v-col>
                    </v-row>


                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-sheet rounded="lg" class="card" style="" v-if="client.client.address_data && client.client.address_data.addres_city">
                  <div class="heading">
                    <span class="card-title">Адрес</span>
                  </div>
                  <v-row class="mt-2">
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Город</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_city"
                          label="Город"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                 
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Улица</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_street"
                          label="Улица"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Дом</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_building"
                          label="Дом"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Строение</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_house"
                          label="Строение"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Квартира</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_flat"
                          label="Квартира"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>
         

                    
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Индекс</label>
                      <v-text-field
                          v-model="client.client.address_data.addres_index"
                          label="Индекс"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-sheet>

                <v-sheet rounded="lg" class="card" style="" v-else>
                  <div class="heading">
                    <span class="card-title">Адрес</span>
                  </div>
                  <v-row class="mt-2">
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Город</label>
                      <v-text-field
                          v-model="address_data_def.addres_city" 
                          label="Город"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                 
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Улица</label>
                      <v-text-field
                          v-model="address_data_def.addres_street" 
                          label="Улица"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Дом</label>
                      <v-text-field
                          v-model="address_data_def.addres_building" 
                          label="Дом"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Подъезд</label>
                      <v-text-field
                          v-model="address_data_def.addres_enter" 
                          label="Подъезд"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Строение</label>
                      <v-text-field
                          v-model="address_data_def.addres_house"
                          label="Строение"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Квартира</label>
                      <v-text-field
                          v-model="address_data_def.addres_flat"
                          label="Квартира"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>
         

                    
                    <v-col
                        md="6"
                        sm="12"
                    >
                      <label>Индекс</label>
                      <v-text-field
                          v-model="address_data_def.addres_index"
                          label="Индекс"
                          outlined
                          dense
                          style="height: 48px;margin-top: 10px"
                          class="rounded-lg"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-sheet>

              </v-col>
            </v-row>


                    <v-row>
                      <v-col
                          md="12"
                      >
                        <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                          <div style="padding: 20px 20px 0 20px">
                            <span class="card-title">Родственники</span>
                          </div>
                          <v-data-table
                              v-if="listRelatives"
                              :headers="headersRelations"
                              :items="listRelatives.relatives"
                              :hide-default-footer="true"
                              disable-pagination
                              item-key="id"
                              class="elevation-1"
                          >
                            <template v-slot:body="{ items, headers }">
                              <tbody name="list" is="transition-group" v-if="items.length > 0">
                              <tr v-for="item in items" :key="item.id">
                                <td @click="editRelation(item)">
                                  {{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}
                                </td>
                                <td>{{ item.relatives_type.name }}</td>
                                <td>{{ item.phone }}</td>
                              </tr>
                              </tbody>
                              <tbody v-else>
                              <tr class="v-data-table__empty-wrapper">
                                <td :colspan="headers.length">Родственников не найдено</td>
                              </tr>
                              </tbody>
                            </template>
                          </v-data-table>
                          <v-btn class="button__lighten-success" @click="addRelation" style="margin: 20px 0 20px 20px">
                            Добавить
                          </v-btn>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                      <v-data-table
                          v-if="buyList && buyList.data && buyList.data.data"
                          :headers="headersPurchase"
                          :items="buyList ? buyList.data.data : []"
                          :hide-default-footer="true"
                          disable-pagination
                          no-data-text="Нет покупок"
                          :page="pagePurchase"
                          item-key="subscribe"
                          class="elevation-1"
                      >
                        <template v-slot:item.number="{ item }">
                          <router-link
                              :to="{name: 'Sale', params: {client: client.client, buy_id: item.buy.id, type: 'info', for: 'client', deal: null}}"
                              style="text-decoration: none; color: black;"
                          >
                            {{ item.number }}
                          </router-link>
                        </template>
                        <template v-slot:item.amount_payment="{ item }">
                          {{ item.amount_payment }} ₽
                        </template>
                        <template v-slot:item.amount_sale="{ item }">
                          {{ item.amount_sale }} ₽
                        </template>
                      </v-data-table>
                      <v-data-table
                          v-else
                          :headers="headersPurchase"
                          :items="buyList ? buyList.data.data : []"
                          :hide-default-footer="true"
                          disable-pagination
                          no-data-text="Загрузка покупок..."
                          :page="pagePurchase"
                          item-key="subscribe"
                          class="elevation-1"
                      >
                        <template v-slot:item.number="{ item }">
                          <router-link
                              :to="{name: 'Sale', params: {client: client.client, buy_id: item.buy.id, type: 'info', for: 'client', deal: null}}"
                              style="text-decoration: none; color: black;"
                          >
                            {{ item.number }}
                          </router-link>
                        </template>
                        <template v-slot:item.amount_payment="{ item }">
                          {{ item.amount_payment }} ₽
                        </template>
                        <template v-slot:item.amount_sale="{ item }">
                          {{ item.amount_sale }} ₽
                        </template>
                      </v-data-table>
                      <v-card-actions
                          class="d-flex justify-content-between"
                          style="padding: 20px !important;"
                          v-if="buyList"
                      >
                        <div>
                          <span class="desktopRegularLabel"><span>Показано с {{ 10 * (pagePurchase - 1) + 1 }} по {{ 10 * pagePurchase }} из {{ buyList.listLength }} результатов</span></span>
                        </div>
                        <div>
                          <v-pagination
                              v-model="pagePurchase"
                              circle
                              color="#629F33"
                              :length="buyList.paginationLength"
                              :total-visible="6"
                          ></v-pagination>
                        </div>
                      </v-card-actions>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                        v-if="listNotes"
                        :headers="headersNotes"
                        :items="listNotes.notes"
                        no-data-text="Заметок не найдено"
                        :hide-default-footer="true"
                        disable-pagination
                        item-key="id"
                        class="elevation-1"
                    >
                      <template v-slot:item="{ item, index }">
                        <tr :style="editNoteStatus && editNoteId === item.id ? 'background: #E0ECD6 !important' : 'background: #fff !important'">
                          <td class="text-start">{{ index + 1 }}</td>
                          <td class="text-start">{{ item.note }}</td>
                          <td class="text-start">
                            <div class="d-flex" style="align-items: center">
                              <div>
                                <v-img :src="client.client.photo" :alt="client.client.name" style="height: 24px; width: 24px; border-radius: 12px;"></v-img>
                              </div>
                              <div class="ml-2">
                                {{ client.client.last_name }} {{ client.client.first_name }} {{ client.client.middle_name }}
                              </div>
                            </div>
                          </td>
                          <td class="text-start">
                            <v-menu
                                bottom
                                left
                                offset-y
                                rounded="lg"
                                content-class="custom__menu"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    primary
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="dots-button__actions"
                                >
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>

                              <v-list>
                                <v-list-item
                                    @click="editNote(item.id, item.note)"
                                >
                                  <v-list-item-title>Редактировать</v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    @click="deleteNote(item.id)"
                                >
                                  <v-list-item-title>Удалить</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>

                    <div class="note-title mt-4 mb-2">
                      Новая заметка
                    </div>
                    <v-form ref="noteForm" @submit.prevent="noteSubmit">
                      <v-textarea
                          v-model="note"
                          :rules="noteRules"
                          rounded
                          outlined
                          dense
                          required
                          auto-grow
                          background-color="#fff"
                          rows="5"
                          style="width: 100%; height: 150px"
                      ></v-textarea>

                      <v-row class="justify-end justify-end-bottom mb-5 mr-1">
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                            style="font-size: 13px; font-weight: 700; padding: 8px 20px !important; align-content: center"
                        >
                          <span style="font-size: 13px !important; line-height: 16px !important;">
                            {{ editNoteStatus ? 'Сохранить' : 'Добавить' }}
                          </span>
                        </button>
                      </v-row>
                    </v-form>

                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet
                        max-height="80px"
                        rounded="lg"
                        style="padding: 20px 32px;"
                    >
                      <v-tabs
                          id="horizontal_tabs"
                          v-model="call_tab"
                      >
                        <v-tab
                            v-for="item in callsTabs"
                            :key="item.tab"
                            class="ml-4"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>
                    </v-sheet>
                    <v-tabs-items  v-model="call_tab" class="mt-5">
                      <v-tab-item>
                        <template
                            v-if="clientCalls"
                        >
                          <v-data-table
                              :headers="headersCall"
                              :items="clientCalls ? clientCalls.clientCalls.directionIn : []"
                              :hide-default-footer="true"
                              disable-pagination
                              no-data-text="Список звонков не найден"
                              item-key="subscribe"
                              class="elevation-1"
                          >
                            <template v-slot:item.duration="{item}">
                              {{ Math.trunc(+item.duration/60) }} мин 
                              {{ +item.duration - Math.trunc(+item.duration/60)*60 }} сек
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <a v-if="item && item.url && item.date" :href="item.url" target="a_blank"><v-icon small v-on="on">mdi-play-circle-outline</v-icon></a>
                              <!-- <v-tooltip
                                  top
                                  content-class="black tooltip-top"
                                  v-if="item && item.url && item.date"
                              >
                                Прослушать
                                <template v-slot:activator="{ on }">
                                  <div v-if="!audioPlayed" @click="playCall(item.url,false)" class="logo-play">
                                    <v-icon small v-on="on">mdi-play-circle-outline</v-icon>
                                  </div>
                                  <div v-else @click="playCall(item.url,true)" class="logo-play">
                                    <v-icon small v-on="on">mdi-pause-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-tooltip> -->
                              <span v-else> Нет действий</span>
                            </template>
                          </v-data-table>
                        </template>
                      </v-tab-item>
                      <v-tab-item>
                        <template
                            v-if="clientCalls"
                        >
                          <v-data-table
                              :headers="headersCall"
                              :items="clientCalls ? clientCalls.clientCalls.directionOut : []"
                              :hide-default-footer="true"
                              disable-pagination
                              no-data-text="Список звонков не найден"
                              item-key="subscribe"
                              class="elevation-1"
                          >
                            <template v-slot:item.duration="{item}">
                              {{ Math.trunc(+item.duration/60) }} мин 
                              {{ +item.duration - Math.trunc(+item.duration/60)*60 }} сек
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <a v-if="item && item.url && item.date" :href="item.url" target="a_blank"><v-icon small v-on="on">mdi-play-circle-outline</v-icon></a>
                              <!-- <v-tooltip
                                  top
                                  content-class="black tooltip-top"
                                  v-if="item && item.url && item.date"
                              >
                                Прослушать
                                <template v-slot:activator="{ on }">
                                  <div v-if="!audioPlayed" @click="playCall(item.url,false)" class="logo-play">
                                    <v-icon small v-on="on">mdi-play-circle-outline</v-icon>
                                  </div>
                                  <div v-else @click="playCall(item.url,true)" class="logo-play">
                                    <v-icon small v-on="on">mdi-pause-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-tooltip> -->
                              <span v-else> Нет действий</span>
                            </template>
                          </v-data-table>
                        </template>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                        :headers="headersSubscribe"
                        :items="membershipList ? membershipList.data.data : []"
                        :hide-default-footer="true"
                        disable-pagination
                        no-data-text="Список не найден"
                        item-key="subscribe"
                        class="elevation-1"
                    >
                      <template v-slot:item.product.name="{ item }">
                        <router-link :to="{ name: 'CardSubscribe', params: {client_id: client_id, product_id: item.product.id} }" style="align-items: center; text-decoration: none; color: #000">
                          {{ item.product.name }}
                        </router-link>
                      </template>
                      <template v-slot:item.startdate="{ item }">
                        {{ item.startdate.split('000')[1] ? '' : item.startdate }}
                      </template>
                      <template  v-slot:item.status="{ item }">

                        <v-btn
                            v-if="item.status !== 'Продан'"
                            :to="getRoute(item.status,item.product.id)"
                            :class="getClass(item.status)"
                        >
                          {{ getNameStatus(item.status) }}
                        </v-btn>
                        <v-btn
                            v-if="item.status === 'Продан'"
                            @click="activateProduct(item.product.id)"
                            :class="getClass(item.status)"
                        >
                          {{ getNameStatus(item.status)}}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet rounded="lg" class="card col-8" style="padding: 0 !important;">
                      <div style="padding: 20px !important;">
                        <VueDatePicker
                            no-title
                            no-header
                            range
                            :rangeInputText="dateVisits.start === dateVisits.end ? '%d' : '%d - %d'"
                            format="DD MMMM"
                            color="#629f34"
                            v-model="dateVisits"
                            style="flex: none !important;"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__button"
                                ref="activator"
                                type="button"
                            >
                              <v-icon
                                  dark
                                  right
                                  small
                                  class="mr-2"
                              >
                                mdi-calendar-blank-outline
                              </v-icon>  {{ date }}
                            </button>
                          </template>
                        </VueDatePicker>
                      </div>
                      <v-data-table
                          v-if="visits"
                          :headers="headersAttendance"
                          :items="visits.visits"
                          no-data-text="Нет посещении по текущей дате"
                          
                          class="elevation-1 mt-3 custom__table"
                      >
                      </v-data-table>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet rounded="lg" class="card" style="padding: 0 !important;">
                      <v-form
                          ref="filterLessonForm"
                          v-model="valid_lesson"
                      >
                        <v-container>
                          <v-row style="padding: 20px 20px 0 20px">
                            <v-col
                                md="6"
                            >
                              <label>Исполнитель</label>
                              <v-select
                                  @input="collectData"
                                  class="rounded-lg custom__select"
                                  v-model="filterLesson.specialist"
                                  :items="filterFormLesson.specialist"
                                  item-value="id"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>
                            </v-col>
                            <v-col
                                md="6"
                            >
                              <label>Тип занятия</label>
                              <v-select
                                  @input="collectData"
                                  class="rounded-lg custom__select"
                                  v-model="filterLesson.type"
                                  :items="lessonTypes"
                                  item-value="type_id"
                                  item-text="type_name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>
                            </v-col>
                            <v-col
                                md="6"
                            >
                              <label>Услуга</label>
                              <v-select
                                  @input="collectData"
                                  class="rounded-lg custom__select"
                                  v-model="filterLesson.service"
                                  :items="filterFormLesson.service"
                                  item-value="id"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>
                            </v-col>
                            <v-col
                                md="6"
                            >
                              <label>Помещение</label>
                              <v-select
                                  @input="collectData"
                                  class="rounded-lg custom__select"
                                  v-model="filterLesson.room"
                                  :items="filterFormLesson.room"
                                  item-value="id"
                                  item-text="name"
                                  :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                  label="Выбрать"
                                  append-icon="mdi-chevron-down"
                                  outlined
                                  dense
                                  required
                                  style="height: 48px;margin-top: 10px"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row style="padding: 5px 20px 10px 30px">
                            <template v-if="!dialogButton">
                              <button
                                  class="button custom__filter-button mt-5"
                                  type="button"
                              >
                                Применить
                              </button>
                            </template>
                            <template v-else>
                              <button
                                  class="button custom__filter-button mt-5"
                                  type="button"
                                  style="background-color: #A13453 !important;color: #fff !important;"
                                  @click="filterLessons(filterLesson)"
                              >
                                Применить
                              </button>
                              <button
                                  class="button custom__filter-button mt-5 ml-3"
                                  type="button"
                                  style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                  @click="clearData"
                              >
                                Сбросить фильтр
                              </button>
                            </template>
                          </v-row>
                      </v-container>
                      </v-form>
                      <v-data-table
                          :headers="headersLesson"
                          :items="scheduleList ? scheduleList.data : []"
                          :page="pageLessons"
                          :hide-default-footer="true"
                          disable-pagination
                          no-data-text="Список занятии не найден"
                          class="elevation-1 mt-3 custom__table"
                      >
                        <template v-slot:item.start_date="{item}">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: item.id} }" style="text-decoration: none; color: black">
                            {{ item.start_date }}
                          </router-link>
                        </template>
                        <template v-slot:item.type="{item}">
                          {{ getStatusTypeLessons[item.type] }}
                        </template>
                        <template v-slot:item.status="{item}">
                          <span :class="getClassLessons(item.status)">{{ getStatusLessons[item.status] }}</span>
                        </template>
                      </v-data-table>
                      <v-card-actions
                          class="d-flex justify-content-between"
                          style="padding: 20px !important;"
                          v-if="scheduleList && scheduleList.data && scheduleList.data.length > 10"
                      >
                        <div></div>
                        <div>
                          <v-pagination
                              v-model="pageLessons"
                              circle
                              color="#629F33"
                              :length="scheduleList.paginationLength"
                              :total-visible="6"
                          ></v-pagination>
                        </div>
                      </v-card-actions>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet rounded="lg" class="card d-flex">
                      <VueDatePicker
                        @input="collectDataRange"
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="accountReportFilter.date_schedule"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="accountReportFilter.date_schedule">{{ date }}</span>
                            <span v-else style="color: gray">Выберите период</span>
                          </div>
                          <v-icon
                              medium
                              right
                              class="ml-5"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                        </button>
                      </template>
                    </VueDatePicker>
                      <v-btn
                          dark
                          class="filter-button"
                          @click="makeAccountReport()"
                          style="margin-top: 10px !important; margin-left:50px; padding: 22px !important;"
                      >
                        Сформировать
                      </v-btn>
                    </v-sheet>
                    <v-data-table
                        :headers="headersReport"
                        :items="(accountReports && accountReports.data && accountReports.data.data) ? accountReports.data.data : []"
                        :hide-default-footer="true"
                        disable-pagination
                        no-data-text="Список не найден"
                        item-key="report"
                        class="elevation-1 mt-3"
                    >
                      <template v-slot:body.prepend>
                        <tr>
                          <td colspan="4" class="text-right" style="color: #767676;">Долг клиента на начало периода:</td>
                          <td>{{ (accountReports && accountReports.data && accountReports.data.data) ? accountReports.data.account_start_up : 0}}</td>
                          <td>{{ (accountReports && accountReports.data && accountReports.data.data) ? accountReports.data.account_start_down : 0}}</td>
                        </tr>
                      </template>
                      <template v-slot:body.append>
                        <!-- <tr>
                          <td colspan="4" class="text-right" style="color: #767676;">Долг клиента на </td>
                          <td>0.0</td>
                          <td>0.0</td>
                        </tr> -->
                        <tr>
                          <td colspan="4" class="text-right" style="color: #767676;">Обороты за период:</td>
                          <td>{{ (accountReports && accountReports.data && accountReports.data.data) ? accountReports.data.account_up : 0}}</td>
                          <td>{{ (accountReports && accountReports.data && accountReports.data.data) ? accountReports.data.account_down : 0}}</td>
                        </tr>
                        <tr>
                          <td colspan="4" class="text-right" style="color: #767676;">Долг клиента на конец периода:</td>
                          <!-- <td>0.0</td> -->
                          <td v-if="accountReports && accountReports.data && accountReports.data.data" colspan="2">{{((accountReports.data.account_down - accountReports.data.account_up) > 0) ? '+' + (accountReports.data.account_down - accountReports.data.account_up) : '-'+(accountReports.data.account_down - accountReports.data.account_up)}}</td>
                          <td v-else colspan="2">0</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                        :headers="headersPackage"
                        :items="packList ? packList.data.data : []"
                        :hide-default-footer="true"
                        disable-pagination
                        no-data-text="Список не найден"
                        item-key="package"
                        class="elevation-1"
                    >
                      <template v-slot:item.product.name="{ item }">
                        <router-link :to="{ name: 'CardSubscribe', params: {client_id: client_id, product_id: item.product.id} }" style="align-items: center; text-decoration: none; color: #000">
                          {{ item.product.name }}
                        </router-link>
                      </template>
                      <template  v-slot:item.status="{ item }">
                        <v-btn
                            v-if="item.status !== 'Продан'"
                            :to="getRoute(item.status,item.product.id)"
                            :class="getClass(item.status)"
                        >
                          {{ getNameStatus(item.status)}}
                        </v-btn>
                        <v-btn
                            v-if="item.status === 'Продан'"
                            @click="activateProduct(item.product.id)"
                            :class="getClass(item.status)"
                        >
                          {{ getNameStatus(item.status)}}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item>
                  
                    <div style="display:flex; align-items:center; margin:20px 0px;">

                          <button class="button button__success" @click="selectFile()">Добавить файл</button>

                          <input @change="handleImage" class="custom-input" type="file" ref="file" hidden>


                          <button v-if="image" @click="saveFile()" class="button button__success" style="margin-left:10px;">Сохранить</button>
                      </div>

                    <v-data-table
                        :headers="headersFiles"
                        :items="(fileList && fileList.data) ? fileList.data : []"
        
                        no-data-text="Список не найден"
                        item-key="package"
                        class="elevation-1"
                    >
                    <template v-slot:item.file="{ item }">
                        <a target="a_blank" :href="item.address">{{item.file.name}}</a>
                      </template>
                      <template v-slot:item.modification_date="{ item }">
                          <span v-if="item.modification_date && item.modification_date.split('T')">
                          {{ item.modification_date.split('T')[0].split('-')[2] + '.' + item.modification_date.split('T')[0].split('-')[1] + '.' + item.modification_date.split('T')[0].split('-')[0] + ' ' + item.modification_date.split('T')[1] }}
                        </span>
                        </template>
                    </v-data-table>
                  </v-tab-item>

                  <v-tab-item>
                    <v-data-table
                        :headers="headersContract"
                        :items="(contractList && contractList.data) ? contractList.data : []"
        
                        no-data-text="Список не найден"
                        item-key="package"
                        class="elevation-1"
                    >

                    <template v-slot:item.contract="{ item }">
                        <span style="cursor:pointer;" @click="printContract(item.contract.id)">{{ item.contract.name }} </span>
                      </template>

                      <template v-slot:item.date="{ item }">
                          <span v-if="item.date && item.date.split('T')">
                          {{ item.date.split('T')[0].split('-')[2] + '.' + item.date.split('T')[0].split('-')[1] + '.' + item.date.split('T')[0].split('-')[0] + ' ' + item.date.split('T')[1] }}
                        </span>
                        </template>
                      
                      
                    </v-data-table>
                    
                  </v-tab-item>

                  

                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
          >
            <v-card rounded="lg">
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Родственник</h4>
                </div>
                <v-btn icon @click="dialog = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="relationForm" @submit.prevent="addRelationSubmit">
                    <v-row>
                      <v-col
                          cols="12"
                      >
                        <v-switch
                            label="Существующий клиент"
                            style="height: 30px;"
                            color="#629F33"
                            inset
                            @change="changeState"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Телефон <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="phone"
                            :rules="phoneRules"
                            v-mask="'+7 (###) ###-##-###'"
                            label="Телефон"
                            required
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Фамилия</label>
                        <v-text-field
                            v-model="middle_name"
                            label="Фамилия"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Имя <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="first_name"
                            :rules="firstNameRules"
                            label="Имя"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Отчество</label>
                        <v-text-field
                            v-model="last_name"
                            label="Отчество"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Дата рождения</label>
                        <template>
                          <VueDatePicker
                              no-title
                              no-header
                              :minDate="(new Date()).setYear((new Date()).getYear() - 100)"
                              :maxDate="new Date()"
                              color="#629f34"
                              v-model="date_birthday"
                              placeholder="Выбрать"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker"
                                  ref="activator"
                                  type="button"
                                  style="white-space: nowrap; width: 80% !important;"
                              >
                                {{ date }}
                                <v-icon
                                    medium
                                    right
                                    class="ml-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </button>
                            </template>
                          </VueDatePicker>
                        </template>
                      </v-col>
                      <v-col
                          v-if="unsetClient"
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Пол</label>
                        <v-select
                            v-model="gender"
                            :items="genderTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Пол"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          v-if="!unsetClient"
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <label>Родственник <span style="color: #D53025">*</span></label>
                        <div class="d-flex">
                          <v-autocomplete
                              colspan="1"
                              :items="listClient ? listClient.client : []"
                              item-value="client_id"
                              item-text="name"
                              placeholder="Поиск клиентов"
                              no-data-text="Результатов не найдено"
                              clearable
                              color="#629F33"
                              item-color="success"
                              :search-input.sync="search"
                              v-model="select"
                              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg'}"
                              :no-filter=true
                              class="rounded-lg"
                              append-icon=""
                              hide-details
                              outlined
                              dense
                              background-color="white"
                              style="height: 30px;margin-top: 10px"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon>mdi-magnify</v-icon>
                            </template>
                          </v-autocomplete>
                          <v-btn v-show="select !== null" :to="{ name: 'Desktop', params: {client_id: select} }"
                                 class="button__lighten-success ml-3"
                                 style="height: 40px !important;margin-top: 10px !important;">
                            Рабочий стол
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Степень родства <span style="color: #D53025">*</span></label>
                        <v-select
                            v-if="listRelativesTypes"
                            v-model="relative_type"
                            :rules="relativeTypeRules"
                            :items="listRelativesTypes.relatives"
                            item-value="id"
                            item-text="name"
                            label="Степень родства"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="6"
                      >
                        <v-switch
                            v-model="is_representative"
                            label="Законный представитель"
                            color="#629F33"
                            inset
                            style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Лицевой счет</label>
                        <v-select
                            v-model="main_bill"
                            :items="billTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Лицевой счет"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Бонусный счет</label>
                        <v-select
                            v-model="bonus_bill"
                            :items="billTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Бонусный счет"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px;"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-card-actions style="padding: 20px 10px !important;">
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                            :disabled="relative_adding"
                        >
                          Сохранить
                        </button>
                      </v-card-actions>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogRelationEdit"
              persistent
              max-width="600px"
          >
            <v-card rounded="lg">
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Родственник</h4>
                </div>
                <v-btn icon @click="dialogRelationEdit = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" @submit.prevent="editRelationSubmit">
                    <v-row>
                      <v-col
                          cols="12"
                          sm="12"
                          md="12"
                      >
                        <label>Родственник <span style="color: #D53025">*</span></label>
                        <div class="d-flex">
                          <v-text-field
                              v-model="editRelationItems.name"
                              label="Родственник"
                              class="rounded-lg"
                              outlined
                              dense
                              readonly
                              style="height: 48px;margin-top: 10px"
                          ></v-text-field>
                          <v-btn v-show="editRelationItems.id !== null" :to="{ name: 'Desktop', params: {client_id: editRelationItems.id} }"
                                 class="button__lighten-success ml-3"
                                 style="height: 40px !important;margin-top: 10px !important;">
                            Рабочий стол
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Степень родства <span style="color: #D53025">*</span></label>
                        <v-select
                            v-if="listRelativesTypes"
                            v-model="editRelationItems.relative_type"
                            :rules="relativeTypeRules"
                            :items="listRelativesTypes.relatives"
                            item-value="id"
                            item-text="name"
                            label="Степень родства"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="6"
                      >
                        <v-switch
                            v-model="editRelationItems.is_representative"
                            label="Законный представитель"
                            color="#629F33"
                            inset
                            style="margin-bottom: -23px !important; padding-top: 23px; !important;"
                        ></v-switch>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Лицевой счет</label>
                        <v-select
                            v-model="editRelationItems.main_bill"
                            :items="billTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Лицевой счет"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                      >
                        <label>Бонусный счет</label>
                        <v-select
                            v-model="editRelationItems.bonus_bill"
                            :items="billTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Бонусный счет"
                            class="rounded-lg"
                            outlined
                            dense
                            required
                            style="height: 30px;margin-top: 10px;"
                        ></v-select>
                      </v-col>
                      <v-card-actions style="padding: 20px 10px !important;">
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                        >
                          Сохранить
                        </button>
                        <button
                            class="button button__danger ml-3"
                            ref="activator"
                            type="button"
                            style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                            @click="deleteRelationSubmit"
                        >
                          Удалить
                        </button>
                      </v-card-actions>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCard"
              persistent
              max-width="600px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogCard = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 70px;">
                <v-container>
                  <v-form ref="form" @submit.prevent="addCard">
                    <div class="text-center">
                      <h3 class="text-center">Добавить новую карту</h3>
                    </div>
                    <v-row
                        align="center"
                        class="mt-5"
                    >
                      <v-col
                          cols="12"
                          sm="6"
                          md="8"
                      >
                        <v-text-field
                            v-model="card_number"
                            :rules="cardNumberRules"
                            label="Номер карты"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <button
                            class="button button__success purpure-button"
                            ref="activator"
                            type="button"
                            style="padding: 8px 20px !important; font-weight: 700;"
                            @click="searchBracelet"
                        >
                          Сгенерировать
                        </button>
                      </v-col>

                      <button
                          class="button button__secondary"
                          ref="activator"
                          type="submit"
                          style="margin:auto; font-weight: 700;"
                      >
                        Сохранить
                      </button>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogPayment"
              persistent
              max-width="540px"
          >

            <v-form
                ref="formPayment"
                v-model="validDialogPayment"
            >
              <v-card rounded="lg">
                <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Взнос на лицевой счет</h4>
                  </div>
                  <v-btn icon @click="dialogPayment = false">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row class="d-flex justify-space-between mt-5">
                      <div style="width: 35%; display: flex; align-items: center; justify-content: end">
                        <span class="payment-text">Чек на</span>
                      </div>
                      <div style="width: 65%">
                        <v-btn-toggle
                            mandatory
                            background-color="white"
                            class="mx-4 rounded-lg"
                            v-model="dialogTypeSender"
                        >
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-phone-incoming-outline
                            </v-icon>
                            Телефон
                          </v-btn>
                          <v-btn>
                            <v-icon
                                small
                                dark
                                class="mr-2"
                            >
                              mdi-email-outline
                            </v-icon>
                            Эл. почту
                          </v-btn>
                        </v-btn-toggle>
                      </div>
                    </v-row>

                    <v-btn-toggle
                        v-model="dialogTypeOfPayment"
                        mandatory
                        background-color="#FFFFFF"
                        class="rounded-lg"
                        style="margin-top: 40px; width: 100%"
                    >
                      <v-btn width="50%">
                        Наличные
                      </v-btn>
                      <v-btn width="50%">
                        Карта
                      </v-btn>
                    </v-btn-toggle>
                    <v-row class="mt-5">
                      <v-col cols="12">
                        <label>Касса</label>
                        <v-select
                            v-model="cashbox_debit"
                            :rules="cashboxRules"
                            :items="listCashbox"
                            item-text="legal_entity"
                            item-value="serial"
                            class="rounded-lg"
                            label="Выбрать"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            hide-details
                            dense
                            required
                            color="#629F33"
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <label>Л/С</label>
                        <v-select
                            v-model="bill_debit"
                            :rules="mainBillRules"
                            :items="listBill ? listBill.list : []"
                            item-text="deposit_name"
                            item-value="deposit_id"
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            label="Выбрать"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            color="#629F33"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <label>Сумма взноса</label>
                        <v-text-field
                            v-model="make_summ"
                            :rules="makeSummRules"
                            placeholder="0"
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <label>Внесено</label>
                        <v-text-field
                            v-model="summ_contributed"
                            :rules="makeSummRules"
                            placeholder="0"
                            outlined
                            dense
                            class="rounded-lg"
                            color="#629F33"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <label>Сдача</label>
                        <v-text-field
                            v-model="odd_money"
                            outlined
                            disabled
                            dense
                            class="rounded-lg"
                            background-color="#F1F1F1"
                            color="#629F33"
                        >
                          <template v-slot:append>
                            <span style="padding-top: 4px; color: rgba(98, 159, 51, 1)">₽</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn
                            class="button button__success"
                            style="width: 100% !important; height: 48px !important;"
                            type="button"
                            @click="submitFormMakePayment"
                            :disabled="isLoadingCashbox || isLoadingAccount"
                        >
                          Внести
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-form>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {salesActionTypes} from "@/store/modules/sale";
import {clientActionTypes} from '@/store/modules/client';
import {relativesActionTypes} from '@/store/modules/relatives';
import {notesActionTypes} from '@/store/modules/notes';
import {accountActionTypes} from '@/store/modules/account';
import {visitsActionTypes} from '@/store/modules/visits';
import {callsActionTypes} from '@/store/modules/clientCalls';
import {cashboxActionTypes} from '@/store/modules/cashbox';
import {billActionTypes} from '@/store/modules/bill';
import {uisActionTypes} from '@/store/modules/uis';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import {advertisingActionTypes} from "@/store/modules/advertising";
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";

export default {
  name: "CardClient",
  props: ['client_id'],
  components: {
    VueDatePicker,
    Header,
    Menu,
  },
  data() {
    return {
      basePhoto:null,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading2: false,
      isClicked: false,
      link: '#',
      getStatusTypeLessons: ["Индивидуальное", "Групповое"],
      getStatusLessons: [ "Не прибыл",'Прибыл'],
      selectedRange: [],
      accountReportFilter: {
        client_id:null,
        date_schedule:null,
        date_start:null,
        date_end:null
      },
      date_birthday: new Date(),
      date: new Date(),
      dateVisits: {
        start: new Date(),
        end: new Date(),
      },
      dateRules: [
        v => !!v || 'Дата рождения обязательное поле'
      ],
      valid: true,
      validDialogPayment: true,
      valid_lesson: true,
      first_name: '',
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      middle_name: '',
      middleNameRules: [
        v => !!v || 'Фамилия обязательное поле'
      ],
      last_name: '',
      lastNameRules: [
        v => !!v || 'Отчество обязательное поле'
      ],
      gender: '',
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      genderTypes : [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      email: '',
      emailRules: [
        v => !!v || 'Электронная почта обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      relative_type: '',
      relativeTypeRules: [
        v => !!v || 'Степень родства обязательное поле'
      ],
      is_representative: false,
      main_bill: '',
      mainBillRules: [
        v => !!v || 'Лицевой счет обязательное поле'
      ],
      bonus_bill: '',
      bonusBillRules: [
        v => !!v || 'Бонусный счет обязательное поле'
      ],
      billTypes: [
        {type_id: 1, type_name: 'Общий'},
        {type_id: 2, type_name: 'Раздельный'},
      ],
      cashbox_debit: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      bill_debit: null,
      select: null,
      selectRules: [
        v => !!v || 'Нужно выбрать родственника'
      ],
      card_number: null,
      cardNumberRules: [
        v => !!v || 'Номер карты обязательное поле'
      ],
      note: null,
      noteRules: [
        v => !!v || 'Заметки обязательное поле'
      ],
      makeSummRules: [
        v => !!v || 'Сумма обязательная'
      ],
      summ_contributed: null,
      counterInterval: null,
      tab: null,
      purchase_tab: null,
      call_tab: 0,
      dialog: false,
      dialogRelationEdit: false,
      dialogCard: false,
      dialogPayment: false,
      dialogButton: false,
      dialogTypeOfPayment: 1,
      dialogTypeSender: 1,
      make_summ: null,
      odd_money: 0,
      cashbox_id: 1,
      unsetClient: true,
      editNoteStatus: false,
      editNoteId: null,
      deleteNoteId: null,
      search: '',
      selected: [],
      editRelationItems: {
        id: null,
        name: '',
        relative_type: '',
        main_bill: '',
        bonus_bill: '',
        is_representative: false,
      },
      filterLesson: {
        specialist: null,
        type: null,
        service: null,
        room: null,
      },
      filterFormLesson: {
        specialist: [],
        service: [],
        room: [],
      },
      lessonTypes: [
        {type_id: 0, type_name: 'Индивидуальное'},
        {type_id: 1, type_name: 'Групповое'},
      ],
      pageLessons: 1,
      pagePurchase: 1,
      items: [
        {id: 0, tab: 'Основное'},
        {id: 1, tab: 'Покупки'},
        {id: 2, tab: 'Заметки'},
        {id: 3, tab: 'Звонки'},
        {id: 4, tab: 'Членства'},
        {id: 5, tab: 'Посещения'},
        {id: 6, tab: 'Занятия'},
        {id: 7, tab: 'Взаиморасчеты'},
        {id: 8, tab: 'Пакеты'},
        {id: 9, tab: 'Файлы'},
        {id: 10, tab: 'Договоры'}
      ],
      purchases: [
        {tab: 'Абонементы'},
        {tab: 'Услуги'},
        {tab: 'Товары'}
      ],
      callsTabs: [
        {tab: 'Входящие'},
        {tab: 'Исходящие'}
      ],
      headersAccount: [
        {text: 'Тип', align: 'start', sortable: false, value: 'name', width: '70%'},
        {text: 'Сумма', align: 'start', sortable: false, value: 'balance', width: '30%'},
      ],
      headersRelations: [
        {text: 'ФИО', align: 'start', sortable: false, value: 'name', width: '40%'},
        {text: 'Степень родства', align: 'start', sortable: false, value: 'relatives_type', width: '30%'},
        {text: 'Телефон', align: 'start', sortable: false, value: 'phone', width: '30%'},
      ],
      headersPurchase: [
        {text: 'Дата создания', align: 'start', sortable: false, value: 'date', width: '30%'},
        {text: 'Номер продажи', align: 'start', sortable: false, value: 'number', width: '30%'},
        {text: 'Кем создан', align: 'start', sortable: false, value: 'user.name', width: '30%'},
        {text: 'Сумма', align: 'start', sortable: false, value: 'amount_sale', width: '30%'},
        {text: 'Оплачено', align: 'start', sortable: false, value: 'amount_payment', width: '30%'},
      ],
      headersNotes: [
        {text: '#', align: 'start', sortable: false, value: 'id', width: '5%'},
        {text: 'Заметка', sortable: false, value: 'note', width: '45%'},
        {text: 'Сотрудник', sortable: false, value: 'full_name', width: '35%'},
        {text: 'Действие', value: 'actions', sortable: false},
      ],
      headersCall: [
        {text: 'Дата звонка', align: 'start', sortable: false, value: 'date'},
        {text: 'Время звонка', sortable: false, value: 'time'},
        {text: 'Продолжительность', sortable: false, value: 'duration'},
        {text: 'Сотрудник', sortable: false, value: 'user.name'},
        {text: 'Действие', value: 'actions', sortable: false},
      ],
      headersSubscribe: [
        {text: 'Наименование', align: 'start', sortable: false, value: 'product.name', width: '40%'},
        {text: 'Активирован', sortable: false, value: 'startdate', width: '20%'},
        {text: 'Действует по', sortable: false, value: 'enddate', width: '20%'},
        {text: 'Действие', value: 'status', sortable: false}
      ],
      headersAttendance: [
        {text: 'Дата', align: 'start', sortable: false, value: 'date'},
        {text: 'Вход', align: 'start', sortable: false, value: 'date_enter'},
        {text: 'Выход', sortable: false, value: 'date_exit'},
        {text: 'Время в клубе', sortable: false, value: 'time_in'},
        {text: 'Основание', sortable: false, value: 'tiket.name'}
      ],
      headersLesson: [
        {text: 'Дата', align: 'start', sortable: false, value: 'start_date'},
        {text: 'Начало', sortable: false, value: 'start_date_time'},
        {text: 'Окончание', sortable: false, value: 'end_date_time'},
        {text: 'Тип занятия', sortable: false, value: 'type'},
        {text: 'Услуга', sortable: false, value: 'service.name'},
        {text: 'Статус', sortable: false, value: 'status'}
      ],
      headersPackage: [
        {text: 'Наименование', align: 'start', sortable: false, value: 'product.name', width: '40%'},
        {text: 'Активирован', sortable: false, value: 'startdate', width: '20%'},
        {text: 'Действует по', sortable: false, value: 'enddate', width: '20%'},
        {text: 'Действие', value: 'status', sortable: false}
      ],
      headersReport: [
        {text: 'Дата', align: 'start', sortable: false, value: 'column1'},
        {text: 'Регистратор', sortable: false, value: 'column2.type'},
        {text: 'Тип средств', sortable: false, value: 'column3'},
        {text: 'Скидка', sortable: false, value: 'column1'},
        {text: 'Увеличение долга', sortable: false, value: 'column4'},
        {text: 'Уменьшение долга', sortable: false, value: 'column5'}
      ],
      purchases_data: [
        {id: '1', full_name: 'Иванов Иван Иванович', date: '26.07.2022', subscribe: 'Все включено 12+'},
        {id: '1', full_name: 'Иванов Иван Иванович', date: '26.07.2022', subscribe: 'Все включено 12+'}
      ],
      calls_data: [
        {date: '25.07.2022', time: '14:15', duration: '0ч. 4мин.', user_id: '1', full_name: 'Иванов Иван Иванович'},
        {date: '25.07.2022', time: '14:15', duration: '0ч. 4мин.', user_id: '1', full_name: 'Иванов Иван Иванович'},
        {date: '25.07.2022', time: '14:15', duration: '0ч. 4мин.', user_id: '1', full_name: 'Иванов Иван Иванович'}
      ],
      subscribes: [
        {status: 'Активировать', subscribe: 'Членство 1 месяц', date: '25.07.2022', duration: '25.08.2022'},
        {status: 'Разморозить', subscribe: 'Членство 1 месяц', date: '25.07.2022', duration: '25.08.2022'},
        {status: 'Заморозить', subscribe: 'Членство 1 месяц', date: '25.07.2022', duration: '25.08.2022'}
      ],
      lessons: [
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Прибыл'},
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Не прибыл'},
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Отменено'},
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Прибыл'},
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Прибыл'},
        {date: '26.07.2022', start: '12:12', end: '12:12',type: 'Групповое занятие',service: 'Один прыжок',status: 'Прибыл'},
      ],
      packages: [
        {status: 'Активировать', package: '5 прыжков', date: '25.07.2022', duration: '25.08.2022'},
        {status: 'Разморозить', package: '5 прыжков', date: '25.07.2022', duration: '25.08.2022'},
        {status: 'Заморозить', package: '5 прыжков', date: '25.07.2022', duration: '25.08.2022'}
      ],
      reports: [
        {date: '26.07.2022', service: '12:12', count: '12:12',sale: 'Групповое занятие',increase_credit: 'Один прыжок',decrease_credit: 'Не прибыл'},
        {date: '26.07.2022', service: '12:12', count: '12:12',sale: 'Групповое занятие',increase_credit: 'Один прыжок',decrease_credit: 'Отменено'},
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      menu_tab:0,
      sucupd:false,
      audioPlayed:false,
      audioObj:null,
      contractList:[],
      headersContract:[
        {text: 'Представление', align: 'start', sortable: false, value: 'contract',width: '60%'},
        {text: 'Дата', value: 'date', sortable: false,width: '40%'}
      ],
      headersFiles:[
        {text: 'Наименование', align: 'start', sortable: false, value: 'file',width: '30%'},
        {text: 'Дата изменения', value: 'modification_date', sortable: false,width: '30%'},
        {text: 'Отредактировал', value: 'changed_user.name', sortable: false,width: '30%'}
      ],
      fileList:[],
      documents_def:[
        {
          code:"",
          date_start: null,
          issued:null,
          nationality: "Россия",
          number: null,
          seria: null,
          type: "Паспорт"
        }
      ],
      address_data_def:{
        adrress_index:null,
        adrress_flat: null,
        adrress_house:null,
        adrress_enter: null,
        adrress_building: null,
        adrress_street: null,
        adrress_city: null
      },
      showSaveFile:false,
      image:null,
      imageExtension:null,
      imageName:null,
      relative_adding:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      isLoadingCashbox: state => state.cashbox.isLoading,
      isLoadingAccount: state => state.account.isLoading,
      isLoadingRelatives: state => state.relatives.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      client: state => state.client.client,
      listClient: state => state.client.listClient,
      clientUpdated: state => state.client.clientUpdated,
      listNotes: state => state.notes.listNotes,
      listRelatives: state => state.relatives.listRelatives,
      listRelativesTypes: state => state.relatives.listRelativesTypes,
      listBill: state => state.bill.list,
      visits: state => state.visits.visits,
      validationErrors: state => state.client.validationErrors,
      packList: state => state.client.packList,
      membershipList: state => state.client.membershipList,
      buyList: state => state.client.buyList,
      clientCalls: state => state.clientCalls.clientCalls,
      scheduleList: state => state.client.scheduleList,
      accountReports: state => state.client.accountReports,
      listPlatforms: state => state.advertising.listPlatforms,
      listSources: state => state.advertising.listSources,
    })
  },
  methods: {
    handleImage(e) {
      const selectedImage = e.target.files[0]; // get first file
      this.createBase64Image(selectedImage);
    },
    createBase64Image(fileObject) {

      this.imageName = fileObject.name
      this.imageExtension = fileObject.type
      const reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
        this.uploadImage();
      };
      reader.readAsDataURL(fileObject);
    },
    saveFile(){

      const { image } = this;

      const getBase64StringFromDataURL = (dataURL) =>
        dataURL.replace('data:', '').replace(/^.+,/, '');
      
      const image_res = getBase64StringFromDataURL(image);

      this.$store.dispatch(clientActionTypes.saveClientFile, {
        client_id: this.client.client.client_id,
        file: image_res,
        file_name:this.imageName,
        file_extension:this.imageExtension
      }).then(() => {

        this.image = null
        this.imageExtension = null
        this.imageName = null
        
        this.$store.dispatch(clientActionTypes.getContractList, {client_id: this.client_id, type:"file"}).then(data => {
            //this.freezeList = data.data
            if(data){
              this.fileList = data
            }
        })




      })

    },
    selectFile(){
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    printContract(id){
              // this.$store.dispatch(clientActionTypes.printFile,{
              //       file_id: id
              //     }).then((response2) => {
              //       if (response2 && response2.success) {
              //         //печатаем
              //         console.log(response2)
              //         let link = document.createElement('a');
              //         link.href = response2.link;
              //         link.target = 'a_blank';
              //         let filename = 'contract_file' + (Math.floor(Date.now() / 1000)) + '.docx';
              //         link.setAttribute('download', filename);
              //         document.body.appendChild(link);
              //         link.click();
              //         link.remove();

              //       } else {
              //         alert('Ошибка генерации документа')
              //       }
                
              //     })

              this.$store.dispatch(salesActionTypes.printSale,{
                    file_id: id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                    } else {
                      alert('Ошибка генерации документа')
                    }
                
                  })
    },
    setCashboxTerminal(){
      let serial = (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : "00108723658089"
      if (JSON.parse(getItem('select_org-sale'))) {
        let org = JSON.parse(getItem('select_org-sale'));
        serial = org.serial
      }
      if(!this.listCashbox || !this.listCashbox[0]){
        //alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: serial
      }).then((resp) => {
       console.log(resp)
       if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
          this.cashboxTerminal = resp.cashbox.terminals[0].id
       } 
      //  else {
      //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
      //  }
      })
    },
    makeAccountReport(){
      this.accountReportFilter.client_id = this.client_id
      console.log(this.accountReportFilter)
      this.$store.dispatch(clientActionTypes.getAccountReport, {
        client_id: this.client_id,
        date_start: this.accountReportFilter.date_schedule.start,
        date_end: this.accountReportFilter.date_schedule.end
      }).then(response => {
        console.log(response)
			})
    },
    collectDataRange(selected) {
      this.selectedRange.push(selected)
      console.log(this.selectedRange)
      // if (this.selectedRange !== [] || this.clientsFilter.date_creation !== null || this.clientsFilter.date_end !== null || this.clientsFilter.date_schedule !== null) {
      //   this.dialogButtonRange = true;
      // }
    },
    toggleCamera() {
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading2 = true;
      
      const constraints = (window.constraints = {
				audio: false,
				video: true
			});

			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading2 = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
          this.isLoading2 = false;
					alert("May the browser didn't support or there is some errors.");
				});
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      
      this.isPhotoTaken = !this.isPhotoTaken;
      
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 210, 210);
      
      const getBase64StringFromDataURL = (dataURL) =>
        dataURL.replace('data:', '').replace(/^.+,/, '');
      
      this.basePhoto = getBase64StringFromDataURL(document.getElementById("photoTaken").toDataURL("image/jpeg"));

    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
    .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },
    fetchFeedSearch(client_id) {
      this.clientUpdated = false
      this.client_id = client_id;
      this.tab = 0;
      console.log('gggg')
      this.$store.dispatch(clientActionTypes.getCardClient, {client_id}).then((response) => {
        if(response && response.client){
          this.saveClientSearch(response.client)
        }
      })
    },
    saveClientSearch(client){
        this.$store.dispatch(clientActionTypes.saveSearchClient, {
          client_id: client.client_id,
          phone: Array.isArray(client.phone) ? client.phone[0] : client.phone,
          fio: client.last_name + ' ' + client.first_name + ' ' + client.middle_name
        })
          .then((resp) => {
            console.log(resp)
        })
    },
    fetchFeed(client_id) {
      this.client_id = client_id;
      this.tab = JSON.parse(getItem('tab'));
      console.log('gggg2')
      this.$store.dispatch(clientActionTypes.getCardClient, {client_id})
      
    },
    fetchFeedCard(card_id) {
      this.card_number = card_id;
      this.isClicked = false;
    },
    getClassLessons(status) {
      if (status === 0 ) return 'lessons_status_text_red'
      else if (status === 1) return 'lessons_status_text_green'
    },
    getClass(status) {
      if (status === 'Активен') return 'button__block'
      else if (status === 'Заморожен') return 'button__unblock'
      else if (status === 'Закрыт') return 'button__disabled'
      else if (status === 'Продан') return 'button__activate'
    },
    getRoute(status,product_id){
      if (status === 'Активен') return  {name: 'FreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else if (status === 'Заморожен')  return  {name: 'UnfreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else {return {}}
    },
    collectData(selected){
      this.selected.push(selected)
      this.dialogButton = true;
    },
    clearData(){
      this.$store.dispatch(clientActionTypes.getScheduleList, {
        client_id: this.client_id
      }).then((response) => {
        let specialist = [];
        let service = [];
        let room = [];
        for (let item of response.data) {
          if(specialist.indexOf(item.specialist) === -1) {
            specialist.push(item.specialist)
          }
          if(service.indexOf(item.service) === -1) {
            service.push(item.service)
          }
          if(room.indexOf(item.room) === -1) {
            room.push(item.room)
          }
        }
        this.filterFormLesson.specialist = specialist;
        this.filterFormLesson.service = service;
        this.filterFormLesson.room = room;
        this.$refs.filterLessonForm.reset();
        this.selected.length = 0;
        this.dialogButton = false;
      });
    },
    filterLessons(lesson) {
      if (lesson.specialist !== null) {
        this.scheduleList.data = this.scheduleList.data.filter((item) => item.specialist.id === lesson.specialist);
      }
      if (lesson.room !== null) {
        this.scheduleList.data = this.scheduleList.data.filter((item) => item.room.id === lesson.room);
      }
      if (lesson.service !== null) {
        this.scheduleList.data = this.scheduleList.data.filter((item) => item.service.id === lesson.service);
      }
      if (lesson.type !== null) {
        this.scheduleList.data = this.scheduleList.data.filter((item) => item.type === lesson.type);
      }
    },
    activateProduct(item){
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: item,
        client_id:this.client_id
      })
          .then(() => {
            if (this.tab === 4) {
              this.$store.dispatch(clientActionTypes.getMembership, {
                client_id: this.client_id,
              });
            }
            if (this.tab === 8) {
              this.$store.dispatch(clientActionTypes.getPacks, {
                client_id: this.client_id,
              });
            }
          })
    },
    getNameStatus(status){
      if (status === 'Активен') return 'Заморозить'
      else if (status === 'Заморожен') return 'Разморозить'
      else if (status === 'Продан') return 'Активировать'
      else if (status === 'Закрыт') return 'Закрыт'
    },
    getStyle(status) {
      if (status === 'Прибыл') return 'color: #629F33'
      else if (status === 'Не прибыл') return 'color: #D53025'
      else return 'color: #767676'
    },
    changeState(id) {
      if(id === true){
        this.unsetClient = false
      }else{
        this.unsetClient = true
      }
    },
    playCall(url,stop) {
      if(!stop){
        console.log(url)
        this.audioPlayed = true
        var audio = new Audio(url);
        this.audioObj = audio
        audio.play();
      } else {
       var audio = this.audioObj
        audio.pause();
        this.audioPlayed = false
      }
    },
    stopCall(){
      if(this.audioObj){
        this.audioObj.stop()
        this.audioPlayed = false
      }
    },
    updateClient() {
      console.log(this.client.client)
      console.log(this.address_data_def)
      console.log(this.documents_def)
      this.$store.dispatch(clientActionTypes.updateClient, {
        client_id: this.client.client.client_id,
        last_name: this.client.client.last_name,
        first_name: this.client.client.first_name,
        middle_name: this.client.client.middle_name,
        phone: this.client.client.phone,
        email: this.client.client.email,
        gender: this.client.client.gender,
        photo: this.basePhoto,
        from: 'sale2',
        advertising_platform: this.client.client.advertising_platform,
        advertising_source: this.client.client.advertising_source,
        documents: (this.client.client.documents && this.client.client.documents.length > 0) ? this.client.client.documents : this.documents_def,
        adrress_data: (this.client.client.address_data && this.client.client.address_data.addres_city) ? this.client.client.address_data : this.address_data_def,
        birthday:this.client.client.date_birth
      }).then(() => {
        this.sucupd = true
        if (this.client.client.cards.length !== 0) {
          this.$store.dispatch(clientActionTypes.cardEdit, {
            client_id: this.client.client.client_id,
            cards: this.client.client.cards
          }).then(() => {
            this.$router.push({ name: 'Desktop', params: { client_id: this.client.client.client_id } })
          })
        } else {
          this.$router.push({ name: 'Desktop', params: { client_id: this.client.client.client_id } })
        }
      })

    },
    modalBillPayment() {
      console.log(this.listCashbox)
      if(!this.listCashbox || this.listCashbox == null){
        alert('Не выбрана касса!')
      } else {
        this.cashbox_debit = this.listCashbox[0].serial;
      }
      this.dialogPayment = true;
      
      this.$store.dispatch(billActionTypes.getListBill,{client_id: this.client_id});
    },
    submitFormMakePayment() {
      
      if (this.$refs.formPayment.validate()) {
        this.$store.dispatch(cashboxActionTypes.saleReceipt, {
          till_id: this.cashbox_debit,
          type: this.dialogTypeOfPayment + 4,
          service_list: [
            {
              price: this.make_summ,
              sum: this.make_summ,
              count: 1,
              name: "Взнос на лицевой счет",
            }
          ]
        }).then((response) => {
          if (response.success) {
            this.$store.dispatch(accountActionTypes.makePayment, {
              client_id: this.client_id,
              bill_id: this.bill_debit,
              till_id: this.cashbox_debit,
              make_summ: this.make_summ,
              check_number: response.receipt_number,
              type: this.dialogTypeOfPayment + 1,
              terminal_id: (this.dialogTypeOfPayment + 1) === 2 ? this.cashboxTerminal : null,
              transaction_id: (this.dialogTypeOfPayment + 1) === 2 ? response.auth_code : null,
              transaction_date: (this.dialogTypeOfPayment + 1) === 2 ? new Date() : null,
            })
                .then(() => {
                  this.fetchFeed(this.client_id)
                  this.dialogPayment = false;
                })
          }
        })

      }
    },
    addRelation() {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.dialog = true;
    },
    addRelationSubmit() {
      if (this.$refs.relationForm.validate()) {
        if (this.unsetClient === true) {


          this.relative_adding = true

          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            phone: this.phone,
            first_name: this.first_name,
            last_name: this.last_name,
            middle_name: this.middle_name,
            date_birthday: this.date_birthday,
            gender: this.gender,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            unset_client: this.unsetClient
          })
              .then((response) => {

                this.relative_adding = false

                if(!response || !response.success || response.success == false) {
                  alert('Ошибка создания родственника (номер телефона уже существует)')
                }

                this.$store.dispatch(relativesActionTypes.getRelativesList, {
                  client_id: this.client_id
                });
                this.dialog = false;
              })
        } else {

          this.relative_adding = true

          this.$store.dispatch(relativesActionTypes.relativesAdd, {
            client_id: this.client_id,
            relative_type: this.relative_type,
            is_representative: this.is_representative,
            main_bill_type: this.main_bill === 1,
            bonus_bill_type: this.bonus_bill === 1,
            relative_id: this.select,
            unset_client: this.unsetClient
          })
              .then((response) => {

                this.relative_adding = false

                if(!response || !response.success || response.success == false) {
                  alert('Ошибка создания родственника (номер телефона уже существует)')
                }
                this.$store.dispatch(relativesActionTypes.getRelativesList, {
                  client_id: this.client_id
                });
                this.dialog = false;
              })
        }
      }
    },
    editRelation(item) {
      this.$store.dispatch(relativesActionTypes.getRelativesTypesList);
      this.editRelationItems.id = item.id;
      this.editRelationItems.name = item.last_name + ' ' + item.first_name + ' ' + item.middle_name;
      this.editRelationItems.relative_type = item.relatives_type.id;
      this.editRelationItems.is_representative = item.is_representative;
      this.editRelationItems.main_bill = item.shared_main_bill ? 1 : 2;
      this.editRelationItems.bonus_bill = item.shared_bonus_bill ? 1 : 2;
      this.dialogRelationEdit = true;
    },
    editRelationSubmit() {
      this.$store.dispatch(relativesActionTypes.relativesEdit, {
        client_id: this.client_id,
        relative_id: this.editRelationItems.id,
        relative_type: this.editRelationItems.relative_type,
        is_representative: this.editRelationItems.is_representative,
        main_bill_type: this.editRelationItems.main_bill === 1,
        bonus_bill_type: this.editRelationItems.bonus_bill === 1
      })
          .then(() => {
            this.$store.dispatch(relativesActionTypes.getRelativesList, {
              client_id: this.client_id
            });
            this.dialogRelationEdit = false;
          })
    },
    deleteRelationSubmit() {
      this.$store.dispatch(relativesActionTypes.relativesRemove, {
        client_id: this.client_id,
        relative_id: this.editRelationItems.id,
      })
          .then(() => {
            this.$store.dispatch(relativesActionTypes.getRelativesList, {
              client_id: this.client_id
            });
            this.dialogRelationEdit = false;
          })
    },
    stopCard(){
      clearInterval(this.counterInterval)
    },
    searchBracelet() {
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    addCard() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(clientActionTypes.cardAdd, {
          client_id: this.client_id,
          card_number: this.card_number,
        })
            .then(() => {
              this.fetchFeed(this.client_id);
              this.dialogCard = false;
              this.card_number = null;
            })
      }
    },
    unlock(card_id) {
      this.$store.dispatch(clientActionTypes.cardUnlock, {
        card_id: card_id
      })
      .then(() => {
        this.fetchFeed(this.client_id)
      })
    },
    block(card_id) {
      this.$store.dispatch(clientActionTypes.cardBlock, {
        card_id: card_id
      })
      .then(() => {
        this.fetchFeed(this.client_id)
      })
    },
    editNote(id, note) {
      this.editNoteStatus = true;
      this.editNoteId = id;
      this.note = note;
    },
    deleteNote(id) {
      this.deleteNoteId = id;
      this.dialogDeleteNote = true;
    },
    noteSubmit() {
      if (this.$refs.noteForm.validate()) {
        if (this.editNoteStatus === true) {
          this.$store.dispatch(notesActionTypes.notesEdit, {
            client_id: this.client_id,
            note_id: this.editNoteId,
            note: this.note
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
                this.editNoteStatus = false;
              })
        } else {
          this.$store.dispatch(notesActionTypes.notesAdd, {
            client_id: this.client_id,
            note: this.note,
          })
              .then(() => {
                this.$store.dispatch(notesActionTypes.getNotesList, {
                  client_id: this.client_id
                });
                this.note = '';
              })
        }
      }
    },
    deleteNoteSubmit() {
      this.$store.dispatch(notesActionTypes.notesRemove, {
        client_id: this.client_id,
        note_id: this.deleteNoteId,
      })
          .then(() => {
            this.$store.dispatch(notesActionTypes.getNotesList, {
              client_id: this.client_id
            });
            this.dialogDeleteNote = false;
          })
    },
    submit() {
      this.$refs.form.validate()
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          console.log('RESSS'+xmlhttp.responseText)
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
            if(xmlhttp.responseText.length>0)
            {
              if(!vm.cardRightNow)
              {
                var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                transformArray.reverse();
                var resultString = transformArray.length === 7 ? transformArray.join('') : transformArray.join('')+'000000';
                console.log(resultString);
                console.log('Card has been placed on reader: '+resultString); // action here!!!!

                //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                vm.fetchFeedCard(resultString);
                vm.cardRightNow = true;
              }
            }
            else
            {
              vm.counterInterval = setInterval(vm.sendRequest, 1000);
              if(vm.cardRightNow)
              {
                cardRightNow = false;
                console.log('no card');
                console.log('Card has been removed from reader: '); //card removed (may be needed in future)
              }
            }
          }
          else if (xmlhttp.status == 400) {
            console.log('There was an error 400');
          }
          else {
            console.log('something else other than 200 was returned');
          }

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    },
    callOut(phone) {
      if (confirm('Вы собираетесь позвонить клиенту. Продолжить?')) {
        this.$store.dispatch(uisActionTypes.callOut, {
          contact: phone
        })
            .then((response) => {
              if (response.error) {
                alert(response.message);
              }
            });
      }
    }
  },
  mounted() {
    console.log(this.$route.query)

    if(this.$route.query && this.$route.query.clientid){
      this.client_id = this.$route.query.clientid
    }
    

    this.client_id !== undefined ? setItem('card-client_id',this.client_id) : this.client_id = getItem('card-client_id');
    this.fetchFeed(this.client_id)
    this.setCashboxTerminal()
    this.clientUpdated = null
    this.$store.dispatch(advertisingActionTypes.getPlatforms);
    this.$store.dispatch(advertisingActionTypes.getSources);

    setItem('sale-client',null)
    setItem('sale-buyer_saler',null)
  },
  watch: {
    client_file(){
      console.log('file adding')
      console.log(this.client_file)
    },
    summ_contributed: function (value) {
      if (this.make_summ) {
        let odd_money = value - this.make_summ
        if (odd_money > 0) {
          this.odd_money = odd_money
        } else {
          this.odd_money = 0
        }
      }
    },
    tab() {
      setItem('tab',JSON.stringify(this.tab));
      if (this.tab === 0) {
        this.$store.dispatch(relativesActionTypes.getRelativesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 1) {
        this.$store.dispatch(clientActionTypes.getBuyList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 2) {
        this.$store.dispatch(notesActionTypes.getNotesList, {
          client_id: this.client_id
        });
      }
      if (this.tab === 3) {
        this.$store.dispatch(callsActionTypes.clientCalls, {
          client_id: this.client_id,
          direction: this.call_tab
        });
      }
      if (this.tab === 4) {
        this.$store.dispatch(clientActionTypes.getMembership, {
          client_id: this.client_id,
        });
      }
      if (this.tab === 5) {
        let startdate = (this.dateVisits.start.getFullYear()-2) + '-' + ("0" + (this.dateVisits.start.getMonth() + 1)).slice(-2) + '-' + ("0" + (this.dateVisits.start.getDate())).slice(-2)
        let enddate = this.dateVisits.end.getFullYear() + '-' + ("0" + (this.dateVisits.end.getMonth() + 1)).slice(-2) + '-' + ("0" + (this.dateVisits.end.getDate())).slice(-2)
        
        this.$store.dispatch(visitsActionTypes.countVisits, {
          client_id: this.client_id,
          startdate,
          enddate,
        });
      }
      if (this.tab === 6) {
        this.$store.dispatch(clientActionTypes.getScheduleList, {
          client_id: this.client_id
        }).then((response) => {
          let specialist = [];
          let service = [];
          let room = [];
          for (let item of response.data) {
            if(specialist.indexOf(item.specialist) === -1) {
              specialist.push(item.specialist)
            }
            if(service.indexOf(item.service) === -1) {
              service.push(item.service)
            }
            if(room.indexOf(item.room) === -1) {
              room.push(item.room)
            }
          }
          this.filterFormLesson.specialist = specialist;
          this.filterFormLesson.service = service;
          this.filterFormLesson.room = room;
        });
      }
      if (this.tab === 8) {
        this.$store.dispatch(clientActionTypes.getPacks, {
          client_id: this.client_id,
        });
      }
      if (this.tab === 9) {
        this.$store.dispatch(clientActionTypes.getContractList, {client_id: this.client_id, type:"file"}).then(data => {
            //this.freezeList = data.data
            if(data){
              this.fileList = data
            }
            console.log(data)
        })
      }
      if (this.tab === 10) {
        this.$store.dispatch(clientActionTypes.getContractList, {client_id: this.client_id}).then(data => {
            //this.freezeList = data.data
            if(data){
              this.contractList = data
            }
            console.log(data)
        })
      }
    },
    call_tab() {
      this.$store.dispatch(callsActionTypes.clientCalls, {
        client_id: this.client_id,
        direction: this.call_tab
      });
    },
    dateVisits() {
      this.$store.dispatch(visitsActionTypes.countVisits, {
        client_id: this.client_id,
        startdate: this.dateVisits.start,
        enddate: this.dateVisits.end,
      });
    },
    search() {
      if (this.search !== '' || !this.isLoading) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      }
    },
    client_id() {
      setItem('card-client_id',this.client_id)
    },
    dialogCard() {
      if (!this.dialogCard) {
        this.stopCard()
      }
    }
  }
}
</script>

<style scoped>
.edit-avatar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.edit-button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto 0;
  width: 210px;
  height: 210px;
  border-radius: 145px;
  background-color: #F1F1F1;
}

.logo-play {
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom__button {
  width: 220px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 220px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff!important;
}

.custom__filter-button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A!important;
}

.custom__menu {
  max-height: 112px !important;
  max-width: 218px !important;
}

.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}

.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}

.dots-button__actions {
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}

.dots-button__actions[aria-expanded="true"] {
  background: #629F33;
  outline: 4px solid #E0ECD6;
}

.dots-button__actions[aria-expanded="true"] > .v-btn__content .v-icon {
  color: #fff;
}

.dots-button__actions:hover {
  background: #629F33;
}

.dots-button__actions:hover > .v-btn__content .v-icon {
  color: #fff;
}

.purpure-button {
  background-color: #A13453 !important;
}

.custom__table {
  position: relative;
}
.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
@media (min-width: 1904px) {
  .vd-activator .custom__datepicker {
    width: 91% !important;
  }
}

@media (min-width: 1264px) and (max-width: 1390px) {
  .vd-activator .custom__datepicker {
    width: 85% !important;
  }
}

@media (max-width: 1263px) {
  .vd-activator .custom__datepicker {
    width: 83% !important;
  }
}

.v-data-table-header th {
  background-color: #F1F1F1 !important;
  color: #1A1A1A !important;
  border-left: 1px solid #E0E0E0;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: white !important;
  border-bottom: none !important;
}


.v-text-field--outlined >>> fieldset {
  border-color: #E0E0E0;
  font-size: 11px;
}

.v-tabs.theme--light {
  border-radius: 20px !important;
  width: 98% !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab.v-tab--active {
  justify-content: start !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #E0ECD6 !important;
  border-radius: 0 !important;
  color: #629F33 !important;
  height: 40px !important;
}

.v-tabs.theme--light > div > div.v-slide-group__wrapper > div > div.v-tab {
  justify-content: start !important;
  text-transform: none !important;
  text-align: left !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  color: #767676 !important;
  height: 40px !important;
  padding: 8px 12px !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px !important;
  color: #767676 !important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}

.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0 !important;
}


.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.theme--light.v-card > .v-card__text, .theme--light.v-card > .v-card__subtitle {
  color: #000 !important;
}

.web-camera-container {
	 margin-top: 2rem;
	 margin-bottom: 2rem;
	 padding: 2rem;
	 display: flex;
	 flex-direction: column;
	 justify-content: center;
	 align-items: center;
	 border: 1px solid #ccc;
	 border-radius: 4px;
	 width: 500px;
}
 .web-camera-container .camera-button {
	 margin-bottom: 2rem;
}
 .web-camera-container .camera-box .camera-shutter {
	 opacity: 0;
	 width: 450px;
	 height: 337.5px;
	 background-color: #fff;
	 position: absolute;
}
 .web-camera-container .camera-box .camera-shutter.flash {
	 opacity: 1;
}
 .web-camera-container .camera-shoot {
	 margin: 1rem 0;
}
 .web-camera-container .camera-shoot button {
	 height: 30px;
	 width: 30px;
	 display: flex;
	 align-items: center;
	 justify-content: center;
	 border-radius: 100%;
}
 .web-camera-container .camera-shoot button img {
	 height: 15px;
	 object-fit: cover;
}
 .web-camera-container .camera-loading {
	 overflow: hidden;
	 height: 100%;
	 position: absolute;
	 width: 100%;
	 min-height: 150px;
	 margin: 3rem 0 0 -1.2rem;
}
 .web-camera-container .camera-loading ul {
	 height: 100%;
	 position: absolute;
	 width: 100%;
	 z-index: 999999;
	 margin: 0;
}
 .web-camera-container .camera-loading .loader-circle {
	 display: block;
	 height: 14px;
	 margin: 0 auto;
	 top: 50%;
	 left: 100%;
	 transform: translateY(-50%);
	 transform: translateX(-50%);
	 position: absolute;
	 width: 100%;
	 padding: 0;
}
 .web-camera-container .camera-loading .loader-circle li {
	 display: block;
	 float: left;
	 width: 10px;
	 height: 10px;
	 line-height: 10px;
	 padding: 0;
	 position: relative;
	 margin: 0 0 0 4px;
	 background: #999;
	 animation: preload 1s infinite;
	 top: -50%;
	 border-radius: 100%;
}
 .web-camera-container .camera-loading .loader-circle li:nth-child(2) {
	 animation-delay: 0.2s;
}
 .web-camera-container .camera-loading .loader-circle li:nth-child(3) {
	 animation-delay: 0.4s;
}
 @keyframes preload {
	 0% {
		 opacity: 1;
	}
	 50% {
		 opacity: 0.4;
	}
	 100% {
		 opacity: 1;
	}
}
 

</style>